import React from 'react';
import FormattedText from '../../../components/01_atoms/FormattedText';
import { generateClassNameByBehaviorSettings } from '../../../utils/behaviorSettings';
import { BehaviourSettingsType } from '../../../utils/behaviorSettings/prop-types';

import styles from './index.module.scss';

type Props = {
  title?: string;
  text: string;
  style: 'default' | 'christmas';
  behaviorSettings?: BehaviourSettingsType;
  uuid?: string;
};

const BBTextWithTitle = ({
  title = '',
  text,
  style = 'default',
  behaviorSettings,
  uuid,
}: Props) => {
  const classes = [
    'bb',
    styles['bb-text-with-title'],
    styles[`bb-text-with-title--${style}`],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        <div className={styles['bb-text-with-title__content']}>
          {!!title && (
            <FormattedText tag="h2" text={title} className={styles['bb-text-with-title__title']} />
          )}
          <FormattedText text={text} className={styles['bb-text-with-title__text']} />
        </div>
      </div>
    </div>
  );
};

export default BBTextWithTitle;
